<template>
  <div v-if="isOn" class="bg">
      <div class="window">
          <div class="message">
              <p v-html="data.messageData.message"></p>
          </div>
          <div class="buttons">
              <BMButton v-for="choice in data.messageData.choices" :key="choice.label   " @is-clicked="() => {sendResult(choice.data)}">{{ choice.label }}</BMButton>
          </div>
      </div>
  </div>
</template>

<script>
import BMButton from '@/components/BlackMoonUI/BMButton'
export default {
    props: ['isOn', 'data'],
    components: {
        BMButton
    },
    methods: {
        sendResult(choiceData){
            this.data.resolve(choiceData)
            this.$dialog.dismiss()
        }
    }
}
</script>

<style lang="scss" scoped>
    .bg {
        background-color: $transparentDark;
        z-index: 100;
        height: vh(100);
        width: 100vw;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center; 

        .window {
            width: 80%;
            min-height: vh(30);
            background-color: white;
            display: flex;
            flex-direction: column;

            .message {
                flex-grow: 8;
                padding: 20px;
            }

            .buttons {
                flex-grow: 1;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                padding: 10px 10px 8px 10px;
            }
        }
    }
</style>